import React, { Component } from "react";
import classNames from "classnames";
import {Link as PrismicLink, RichText as PrismicRichText} from 'prismic-reactjs';
import {Link} from 'react-router-dom';
import {PrismicConfig} from "../../config";
import "./Resource.css";

export default class Resource extends Component {

	sectionClasses() {
		let classes = {
			"resource-single": true,
		}
		return classNames(classes);
	}
	
	render() {
		const resource = this.props.resource;

		if(!resource) return;

		let to = resource.download ? PrismicLink.url(resource.download, PrismicConfig.linkResolver) : '/';

		return (
			<Link to={to ? to : '/'} className={this.sectionClasses()} target="_blank">
				<i className="icon-download"></i>
				{resource.title && PrismicRichText.render(resource.title, PrismicConfig.linkResolver)}
				{resource.description ? PrismicRichText.render(resource.description, PrismicConfig.linkResolver) : <p>Download</p>}
			</Link>
		);
	}
}	


// WEBPACK FOOTER //
// ./src/components/Resource/Resource.js